"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductList = void 0;
const ProductListFilter_1 = require("./ProductListFilter");
const ProductListRequestHandler_1 = require("./ProductListRequestHandler");
/**
 * Class ProductListHandler
 * New this class when user enter to a product list pages
 * Remember to run `send()` right after create class to get all available filters.
 */
class ProductList {
    constructor(shopId, categoryId, currencyCode, limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT, customerId, customerGroupId) {
        this.items = [];
        this.total = 0;
        this.offset = 0;
        this.shopId = shopId;
        this.categoryId = categoryId;
        this.currencyCode = currencyCode;
        this.filter = new ProductListFilter_1.ProductListFilter();
        this.limit = limit;
        this.customerId = customerId;
        this.customerGroupId = customerGroupId;
    }
    set page(page) {
        this.offset = page * this.limit;
    }
    get page() {
        return Math.round(this.offset / this.limit) + 1;
    }
    get isLastPage() {
        return this.offset >= this.total - this.limit;
    }
    /**
     * Get request params
     */
    get requestParams() {
        return Object.assign({ categoryId: this.categoryId, currencyCode: this.currencyCode, limit: this.limit, offset: this.offset, orderBy: this.orderBy, order: this.order, customerId: this.customerId, customerGroupId: this.customerGroupId, userId: this.userId }, this.filter.requestParams);
    }
    /**
     * Send request to get product list data depending on the current filter conditions.
     */
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield ProductListRequestHandler_1.ProductListRequestHandler.fetchProductList(this.shopId, this.requestParams);
            this.filter.applyFilterResult(result.availableFilters);
            this.items = result.itemContent;
            this.total = result.totalSearchHits;
            return result;
        });
    }
}
exports.ProductList = ProductList;
ProductList.PRODUCT_LIST_DEFAULT_LIMIT = 16;
